import partyImg from '../assets/party.png';

/**
 * Friendly duration text for a free-plan length in days.
 *   30  -> "1 month"     60  -> "2 months"
 *   182 -> "6 months"    365 -> "1 year"
 *   15  -> "15 days"     (anything not a whole month/year falls back to days)
 * Returns null for missing/invalid input so callers can show generic copy.
 */
export function formatFreeDuration(days) {
  const n = Number(days);
  if (!n || n <= 0) return null;
  if (n % 365 === 0) {
    const y = n / 365;
    return `${y} year${y > 1 ? 's' : ''}`;
  }
  if (n % 30 === 0) {
    const m = n / 30;
    return `${m} month${m > 1 ? 's' : ''}`;
  }
  return `${n} days`;
}

const CelebrationModal = ({ isOpen, onClose, durationDays }) => {
  if (!isOpen) return null;

  const friendly = formatFreeDuration(durationDays);

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-[#050125] rounded-[20px] px-8 py-10 max-w-sm w-full text-center">
        {/* Party Icon */}
        <div className="mb-6">
          <img src={partyImg} alt="Celebration" className="w-24 h-24 mx-auto object-contain" />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-white mb-3">
          Congratulations!
        </h2>

        {/* Message — reflects the actual free plan that was granted */}
        <p className="text-white text-base leading-relaxed mb-8">
          {friendly ? (
            <>You have unlocked {friendly}<br />free subscription!</>
          ) : (
            <>You have unlocked your<br />free subscription!</>
          )}
        </p>

        {/* Get Started Button */}
        <button
          onClick={onClose}
          className="mx-auto block px-10 py-3 bg-[#D0A95C] text-[#050125] font-semibold rounded-full hover:bg-[#c49b4f] transition-colors"
        >
          Get Started
        </button>
      </div>
    </div>
  );
};

export default CelebrationModal;
